import { cloneDeep } from 'lodash'

import { empty } from '@sigma-frontend-libs/commons'
import { SendingTypes } from '@sigmasms/shared-types'

import render from './render'

export default {
  name: 'MessagePreview',

  props: {
    value: {
      type: Object,
      default: () => {
        return cloneDeep(empty.sendings.create)
      }
    }
  },

  computed: {
    buttons() {
      const result = []
      const { payload, type } = this.value
      if (payload) {
        switch (type) {
          case SendingTypes.viber: {
            const { text, url } = payload?.button || {}
            if (text && url) {
              result.push({
                text,
                url
              })
            }
          }

          case SendingTypes.vk:
          case SendingTypes.whatsapp: {
            const { buttons } = payload || {}
            if (Array.isArray(buttons) && buttons.length) {
              for (const { text, action } of buttons) {
                if (text && action) {
                  result.push({
                    text,
                    url: action
                  })
                }
              }
            }
          }
        }
      }

      return result
    }
  },

  methods: {
    buttonClickHandler(url) {
      window.open(url, '_blank')
    }
  },

  render
}
